module.exports = __webpack_public_path__ + "static/media/welcome_infographic.e4420abe.svg";